// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__LYLTj","content":"styles_content__3PHS7","selectAll":"styles_selectAll__2on2C"};